import reducer from './reducers';

export { getReviews, getReview, addReview, updateReview, deleteReview } from './actions';

export default reducer;
